export const navMenu = [
  {
    title: "Dashboard",
    link: "/dashboard",
  },
  {
    title: "Manage Events",
    children: [
      {
        title: "Create Event",
        link: "/manage-event",
      },
      {
        title: "Manage Volunteers",
        link: "/manage-volunteers",
      },
    ],
  },
  {
    title: "Volunteering Events",
    link: "/volunteering-events",
  },
  {
    title: "My Profile",
    link: "/my-profile",
  },
  {
    title: "FAQ and Guidelines",
    link: "/faq-and-guidelines",
  },
];

export const banners = [
  {
    name: "Welcome to Rev for Reach",
    image: "banner-1.png",
    description:
      "Your one-stop destination for all things volunteering at MBRDI",
  },
  {
    name: "Welcome to Rev for Reach",
    image: "banner-2.png",
    description:
      "Your one-stop destination for all things volunteering at MBRDI",
  },
  {
    name: "Welcome to Rev for Reach",
    image: "banner-3.png",
    description:
      "Your one-stop destination for all things volunteering at MBRDI",
  },
];

export const convertTimeTo12h = (time: string) => {
  const [hour, minute] = time.split(":");

  const h = parseInt(hour, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  const formattedHour = h % 12 === 0 ? 12 : h % 12;

  return `${formattedHour}:${minute} ${ampm}`;
};

export const convertDate = (dateStr: string, format: "DD MMM YYYY" | "DD-MM-YYYY" = "DD MMM YYYY") => {
  const date = new Date(dateStr);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  if (format === "DD-MM-YYYY") {
    return `${day}-${String(date.getMonth() + 1).padStart(2, "0")}-${year}`;
  }

  return `${day} ${month} ${year}`;
};
